import { PaginacionProps } from "../global/PaginacionInterface";
import { ExpedienteProps } from "../recepcion/ExpedienteInterface";

export const defaultBuscarLibroIndiceAlfabeticoResponse: LibroIndiceAlfabeticoResponse = { currentPageIndex: 0, pageCount: 0, recordCount: 0, records: [], };

export const defaultBuscarLibroIndiceAlfabetico: BuscarLibroIndiceAlfabetico = { idAutoridad: 0, numeroReferencia: '' };

export interface LibroIndiceAlfabeticoProps {
    idLibroIndiceAlfabetico:        number;
    idExpediente:                   number;
    anio:                           number;
    numeroExpediente:               string;
    tipoJuicio:                     string;
    actor:                          string;
    expediente:                     ExpedienteProps;
}

export interface BuscarLibroIndiceAlfabetico {
    idAutoridad:        number;
    numeroReferencia:   string;
}

export interface BuscarLibroIndiceAlfabeticoParams extends PaginacionProps, BuscarLibroIndiceAlfabetico { }

export interface LibroIndiceAlfabeticoResponse {
    records:                        LibroIndiceAlfabeticoProps[];
    currentPageIndex:               number;
    pageCount:                      number;
    recordCount:                    number;
}

export interface DescargarInformacionParams { 
    idAutoridad:        number;
    numeroReferencia:   string;
}